import { ServicesManager } from '@ohif/core';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { useAutoLogout } from '../hooks/useAutoLogout';
import { backofficeRoutes } from './pages/backoffice/backofficeRoutes';
import { DocsPage } from './pages/docs/DocsPage';
import ForbiddenPage from './pages/forbidden/ForbiddenPage';
import { RequireRole } from './pages/forbidden/RequireRole';
import GdataLayout from './pages/GdataLayout';
import { Home } from './pages/Home';
import MyTasks from './pages/MyTasks';
import { NotificationsPage } from './pages/Notifications';
import { ReportsWindow } from './pages/ReportsWindow';
import { ReviewSessionConfiguration } from './pages/ReviewSessionConfiguration';

export { AlertDialog } from './atoms/AlertDialog';
export { Icon } from './atoms/Icon';
export { PreviousItemButtons } from './molecules/PreviousItemButtons';
export { ValidateButton } from './molecules/ValidateButton';
export { GleamerViewerLayout } from './organisms/ViewerLayout/GleamerViewerLayout';
export { AutoLogoutModal } from './organisms/modals/AutoLogoutModal';
export { RequireRole } from './pages/forbidden/RequireRole';

type GdataRoutesProps = {
  servicesManager: ServicesManager;
};

export function GdataRoutes({ servicesManager }: GdataRoutesProps) {
  useAutoLogout();

  return (
    <Routes>
      <Route path="/" element={<GdataLayout />}>
        <Route path="" element={<Home />} />
        <Route path="my-label-tasks" element={<MyTasks />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route
          path="review-session/:taskId"
          element={
            <ReviewSessionConfiguration servicesManager={servicesManager} />
          }
        />
        <Route path="docs" element={<DocsPage />} />
        <Route path="docs/:pageId" element={<DocsPage />} />
        {backofficeRoutes()}
      </Route>
      <Route path="/forbidden" element={<ForbiddenPage />} />
      <Route
        path="/reports"
        element={
          <RequireRole>
            <ReportsWindow />
          </RequireRole>
        }
      />
    </Routes>
  );
}
